interface DiagonalSeparatorProps {
  /** Direction - 'down' slopes down left to right, 'up' slopes up left to right */
  direction?: 'down' | 'up';
  /** Tailwind class for top section color (e.g., 'bg-background', 'bg-card') */
  fromClass?: string;
  /** Tailwind class for bottom section color (e.g., 'bg-card', 'bg-background') */
  toClass?: string;
  /** Height of the separator in pixels */
  height?: number;
  /** Additional className */
  className?: string;
}

// Map common Tailwind bg classes to CSS variable colors
function getColorFromClass(bgClass: string): string {
  const colorMap: Record<string, string> = {
    'bg-background': 'hsl(var(--background))',
    'bg-card': 'hsl(var(--card))',
    'bg-primary': 'hsl(var(--primary))',
    'bg-primary/20': 'hsl(var(--primary) / 0.2)',
    'bg-muted': 'hsl(var(--muted))',
    'bg-card/50': 'hsl(var(--card) / 0.5)',
    'bg-background/50': 'hsl(var(--background) / 0.5)',
  };
  return colorMap[bgClass] || 'currentColor';
}

export default function DiagonalSeparator({
  direction = 'down',
  fromClass = 'bg-background',
  toClass = 'bg-card',
  height = 60,
  className = '',
}: DiagonalSeparatorProps) {

  const fromColor = getColorFromClass(fromClass);
  const toColor = getColorFromClass(toClass);

  return (
    <div
      className={`relative w-full ${className}`}
      style={{ height: `${height}px` }}
      aria-hidden="true"
    >
      {/* Background layer - bottom color */}
      <div
        className="absolute inset-0"
        style={{ backgroundColor: toColor }}
      />

      {/* SVG diagonal - top color */}
      <svg
        className="absolute inset-0 w-full h-full"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {direction === 'down' ? (
          <polygon
            points="0,0 100,0 0,100"
            fill={fromColor}
          />
        ) : (
          <polygon
            points="0,0 100,0 100,100"
            fill={fromColor}
          />
        )}
      </svg>
    </div>
  );
}
